import { render, staticRenderFns } from "./AvailabilityCard.vue?vue&type=template&id=5821e0e5&scoped=true"
import script from "./AvailabilityCard.vue?vue&type=script&lang=js"
export * from "./AvailabilityCard.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityCard.vue?vue&type=style&index=0&id=5821e0e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821e0e5",
  null
  
)

export default component.exports